import { render, staticRenderFns } from "./WelcomeCoins.vue?vue&type=template&id=88286e22&"
import script from "./WelcomeCoins.vue?vue&type=script&lang=ts&"
export * from "./WelcomeCoins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports